import styled from 'styled-components/macro';
import { neutral, space } from '../../../theme/tokens';
import {
  PanelTitle,
  StaffCard,
  StaffCardGrid,
} from '../../common/elements/Staff';

export const AssessmentSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  min-width: 0;
`;

export const AssessmentTitle = styled(PanelTitle)``;

export const AssessmentList = styled(StaffCardGrid)``;

// the "new learning plan" tile
export const AddCard = styled(StaffCard)`
  display: flex;
  padding: 0;
  border: 2px dashed ${neutral.borderStrong};
  background: transparent;
  box-shadow: none;

  &:hover {
    box-shadow: none;
    border-color: ${neutral.textMuted};
  }
`;

export * from '../../common/elements/Assessments';
export * from '../../common/elements/Form';
export * from '../../common/elements/Notifications';
export * from '../../common/elements/Staff';
